export const SET_USER_ROUTER = "SET_USER_ROUTER"; // 存取动态路由表
export const ASYNC_ROUTER_MARK = "ASYNC_ROUTER_MARK";
export const SET_TABLEDATA = "SET_TABLEDATA";
